<div class="wre-timeline-card" [ngClass]="[audit.type ? audit.type : '']">
  <div class="card-body">
    @if (audit.date) {
      <div class="wre-timeline-time">
        {{ audit.date + 'Z' | date: 'EEEE dd MMMM yyyy, hh:mm:ss a' }}
        @if (audit.isCollapsable) {
          <div
            style="float: right; cursor: pointer"
            data-bs-toggle="collapse"
            [attr.data-bs-target]="'#collapse' + title + 'details'"
            aria-expanded="true"
            [attr.aria-controls]="'collapse' + title + 'details'"
            class="collapseIcon">
            <span class="collapseDetailsTitle me-1"> Collapse</span>
            <span class="collapseTitle me-1">Details</span>
            <i class="fas fa-chevron-down"></i>
          </div>
        }
      </div>
    }
    <div class="wre-timeline-action">
      @if (isRoleCreate) {
        <div>
          <p class="mb-1">
            New role created <b> ({{ audit.role.new.name }}) </b>
          </p>
          <span>
            <span class="no-admin-text"> Admins: </span>
            <span class="header-value pe-1 me-1 fw-bold border-end">
              @if (adminsCount < 10) {
                <span>0</span>
              }
              {{ adminsCount }}
            </span>
            <i class="far fa-user px-2"></i>
            <span class="no-admin-text"> Users: </span>
            <span class="header-value pe-1 fw-bold">
              @if (usersCount < 10) {
                <span>0</span>
              }
              {{ usersCount }}
            </span>
            <i class="far fa-users px-2"></i>
            <span class="no-admin-text"> AD Groups: </span>
            <span class="header-value fw-bold border-end pe-1 me-1">
              @if (adGroupsCount < 10) {
                <span>0</span>
              }
              {{ adGroupsCount }}
            </span>
            <i class="far fa-desktop px-2"></i>
            <span class="no-admin-text"> SPs : </span>
            <span class="header-value pe-1 fw-bold border-end pe-1 me-1">
              @if (servicePrincipleCount < 10) {
                <span>0</span>
              }
              {{ servicePrincipleCount }}
            </span>
            <i class="far fa-key px-2"></i>
            <span class="no-admin-text"> Permissions: </span>
            <span class="header-value fw-bold">
              @if (permissionsCount < 10) {
                <span>0</span>
              }
              {{ permissionsCount }}
            </span>
          </span>
        </div>
      }

      @if (isRoleNameUpdate) {
        <div class="no-admin-text">
          Role name changed (<s> {{ audit.role.old.name }} </s>
          <i class="far fa-long-arrow-alt-right mx-2" style="color: purple"></i>
          <b>{{ audit.role.new.name }}</b
          >)
        </div>
      }

      @if (isRoleActiveUpdate) {
        <div>
          Role is set to
          <span
            [ngClass]="{
              'role-setTo-active': audit.role.new.isActive,
              'role-setTo-inactive': !audit.role.new.isActive,
            }">
            {{ audit.role.new.isActive ? 'Active' : 'InActive' }}
          </span>
        </div>
      }

      @if (!isRoleActiveUpdate && !isRoleNameUpdate && !isRoleCreate && audit.title) {
        <div>
          {{ audit.title }}
        </div>
      }
    </div>
    @if (audit.actionBy) {
      <div class="wre-timeline-user">Actioned By: {{ audit.actionBy }}</div>
    }
  </div>
</div>
@if (audit.isCollapsable) {
  <div>
    <div
      [attr.id]="'collapse' + title + 'details'"
      class="collapse tabbed-content show border-top border-light"
      [ngClass]="{ hideTabList: !isRoleCreate }">
      <ul ngbNav #nav="ngbNav" [activeId]="getActiveId(audit)" class="nav-tabs">
        @if (audit.admins || isRoleCreate) {
          <li ngbNavItem="Authorised_Admins">
            <a ngbNavLink>Authorised Admins</a>
            <ng-template ngbNavContent>
              <div class="row">
                <div class="col">
                  <div class="wre-tab-container badges">
                    @if (audit.admins) {
                      @for (admin of audit.admins; track admin) {
                        <div
                          class="badge bg-success me-3 mb-3"
                          [ngClass]="{ 'bg-danger': admin.isRemoved }">
                          @if (admin.isAdded || admin.isRemoved) {
                            <span class="border-end pe-2 me-2">
                              <i
                                class="far"
                                [ngClass]="{
                                  'fa-plus': admin.isAdded,
                                  'fa-minus': admin.isRemoved,
                                }"></i>
                            </span>
                          }
                          <span>
                            {{ admin.displayName }}
                          </span>
                        </div>
                      }
                    } @else {
                      <div class="no-admin-text pb-3">No admins have been selected.</div>
                    }
                  </div>
                </div>
              </div>
            </ng-template>
          </li>
        }
        @if (audit.users || isRoleCreate) {
          <li ngbNavItem="Users">
            <a ngbNavLink>Users</a>
            <ng-template ngbNavContent>
              <div class="row">
                <div class="col">
                  <div class="wre-tab-container">
                    @if (audit.users) {
                      <wre-role-history-data-table [isUser]="true" [listData]="audit.users">
                      </wre-role-history-data-table>
                    }
                    @if (!audit.users) {
                      <div class="no-admin-text">No users have been selected.</div>
                    }
                  </div>
                </div>
              </div>
            </ng-template>
          </li>
        }
        @if (audit.permissions || isRoleCreate) {
          <li ngbNavItem="Permissions">
            <a ngbNavLink>Permissions</a>
            <ng-template ngbNavContent>
              <div class="row">
                <div class="col">
                  <div class="wre-tab-container">
                    @if (audit.permissions) {
                      <wre-role-history-data-table [isUser]="false" [listData]="audit.permissions">
                      </wre-role-history-data-table>
                    }
                    @if (!audit.permissions) {
                      <div class="no-admin-text">No permissions have been selected.</div>
                    }
                  </div>
                </div>
              </div>
            </ng-template>
          </li>
        }
      </ul>
      <div [ngbNavOutlet]="nav"></div>
    </div>
  </div>
}
